export const ADD_NEW_FAQ = "ADD_NEW_FAQ";

export const addNewFaq = () => (dispatch, getState) => {
  let { study } = getState();
  dispatch({ type: ADD_NEW_FAQ, payload: { studyId: study.StudyId, culture: study.Culture } });
};
